import CatalogAside from "widgets/catalog-aside/widget";

let Barba = require('barba.js');

module.exports = Barba.BaseView.extend({
    namespace: 'catalog-page',

    onEnterCompleted: function () {
        let aside = new CatalogAside();
        aside.enableSearch();



        $('.aside__group-name').each(function (index) {
            let assideItemText = $(this).text()
            let assideItemTextLength = $(this).text().length;
            // console.log(assideItemText);
            // console.log(assideItemTextLength);

            // if (assideItemTextLength > 55) {
            //     if ($(window).width() < 1441) {
            //         $(this).closest('.aside__group ').css('height', '58px');
            //
            //     } else {
            //         $(this).closest('.aside__group ').css('height', '78px');
            //
            //     }
            // }
        });
        
    },

    onLeave: function () {

    }
});



// WEBPACK FOOTER //
// resources/assets/src/js/views/catalog-page.js